module.exports = __webpack_public_path__ + "static/media/health7.2787ec8b.svg";